module.exports = __webpack_public_path__ + "media/images/lp-store-b3da990c812ce47bc814f940e4258c43.png";